const GoalVerification = {
    Auditoria: 1,
    ListaPresenca: 2,
    FotoVideo: 3,
    PesquisaSatisfação: 4,
    Relatorio: 5,
    Outros: 6
};

export { GoalVerification };